import React from "react";
import { useAzureResources } from "../hooks/useAzureResources";

export default function TestAzureResources() {
  const { resources, loading, error } = useAzureResources();

  if (loading) return <p>Chargement...</p>;
  if (error) return <p style={{ color: "red" }}>Erreur: {error}</p>;

  return (
    <div>
      <h2>Ressources Azure depuis backend</h2>
      <ul>
        {resources.map((r) => (
          <li key={r}>{r}</li>
        ))}
      </ul>
    </div>
  );
}
